import { useCallback, useEffect, useRef, useState } from "react";
import { api, ApiError } from "../api";
import type { BetSyncStatus } from "../bet-types";
import { Button, EmptyState, Spinner } from "./ui";

const date = new Intl.DateTimeFormat("zh-CN", { timeZone: "Asia/Shanghai", dateStyle: "short", timeStyle: "short" });
export function AdminBetSync() {
  const [status, setStatus] = useState<BetSyncStatus | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const alive = useRef(false);
  const inFlight = useRef(false);
  const load = useCallback(async (sync = false) => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true); setError("");
    try {
      if (sync) await api("/api/admin/bet-records/sync", { method: "POST", body: JSON.stringify({}) });
      const next = await api<BetSyncStatus>("/api/admin/bet-records/status");
      if (alive.current) setStatus(next);
    } catch (reason) { if (alive.current) setError(reason instanceof ApiError ? reason.message : "注单同步状态读取失败，请重试。"); }
    finally { inFlight.current = false; if (alive.current) setBusy(false); }
  }, []);
  useEffect(() => { alive.current = true; void load(); return () => { alive.current = false; }; }, [load]);
  return <section className="admin-panel"><div className="panel-heading"><div><h3>有效投注数据</h3><p>同步已结算注单与退款修订，为返水和 VIP 提供数据；当前不会发放奖励。</p></div><Button busy={busy} onClick={() => void load()}>刷新状态</Button></div>
    {error && <div className="form-alert" role="alert">{error}</div>}
    {!status ? busy ? <Spinner label="正在读取注单同步状态" /> : <EmptyState title="同步状态暂时无法加载" message="请刷新重试。" /> : <div className="ops-note"><div>
      <p>已保存 {status.count} 条 · 已结算 {status.settledCount} 条 · 已退款 {status.refundedCount} 条</p>
      <p>最近同步：{status.lastSyncedAt ? `${date.format(new Date(status.lastSyncedAt))}（北京时间）` : "尚未同步"} · 自动采集{status.backgroundEnabled ? "已开启" : "未开启"}</p>
      <p>采集区间：{status.coverage.from && status.coverage.through ? `${date.format(status.coverage.from * 1000)} — ${date.format(status.coverage.through * 1000)}` : "暂无"}。{status.coverage.hasThirtyDays ? "已保留至少 30 天采集历史，完整性仍须按上游核对。" : "历史不足 30 天，暂不能据此判断完整 VIP 周期。"}</p>
      <p>未归属 {status.unmatchedCount} 条 · 归属冲突 {status.ambiguousCount} 条。币种待商户确认，不合并不同场馆金额。</p>
      {status.lastError && <p role="status">上次同步：{status.lastError}</p>}
      <p>首次同步近一小时，此后按原游标追赶；至少间隔五分钟，延迟五分钟采集。</p>
      <Button disabled={!status.configured || busy || status.syncing} busy={busy} onClick={() => void load(true)}>同步一批注单</Button>
    </div></div>}
  </section>;
}
